import React, { useId } from 'react';
import { FormControl } from '@mui/material';
import { DateTimePickerProps } from '@mui/x-date-pickers/DateTimePicker';
import { Dayjs } from 'dayjs';

import { HelperText } from '../HelperText';
import { Label } from '../Label';

import { StyledDatePicker } from './styles';

export const DatePicker = React.forwardRef(
  (
    {
      id,
      label,
      errorsMessage,
      helperText,
      allowClear = true,
      value,
      onChange,
      slotProps,
      ...otherProps
    }: DateTimePickerProps<Dayjs> & {
      id?: string;
      errorsMessage?: string;
      helperText?: string;
      allowClear?: boolean;
    },
    ref: React.ForwardedRef<HTMLInputElement>
  ) => {
    const generateId = useId();
    const inputId = id || `text-field-${generateId}`;
    const helperTextId = `helper-text-${generateId}`;

    const handleClear = () => {
      if (onChange) {
        onChange(null, { validationError: null });
      }
    };

    return (
      <div>
        {label ? (
          <Label id={inputId} error={!!errorsMessage}>
            {label}
          </Label>
        ) : null}
        <FormControl>
          <StyledDatePicker
            ref={ref}
            value={value}
            onChange={onChange}
            slotProps={{
              field: { clearable: allowClear, onClear: handleClear },
            }}
            {...otherProps}
          />
          {helperText ? (
            <HelperText id={helperTextId}>{helperText}</HelperText>
          ) : null}
        </FormControl>
      </div>
    );
  }
);

DatePicker.displayName = 'DatePicker';
